import React from 'react';
import { StatisticCard } from '@/components/statisticCard';
import { Skeleton } from 'antd';
import {
  FaUsers,
  FaCheckCircle,
  FaTimesCircle,
  FaShieldAlt,
  FaDollarSign,
  FaChartLine,
} from 'react-icons/fa';

interface UserStatsCardsProps {
  stats: {
    total: number;
    active: number;
    inactive: number;
    deactivated: number;
    admins: number;
    creditControl: number;
    sales: number;
  };
  loading?: boolean;
}

export const UserStatsCards: React.FC<UserStatsCardsProps> = ({ stats, loading = false }) => {
  if (loading) {
    return (
      <div className="flex gap-4 overflow-x-auto mb-6">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="min-w-[177px] rounded-lg p-5 bg-white">
            <Skeleton active paragraph={{ rows: 1 }} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-4 overflow-x-auto mb-6">
      <StatisticCard
        title="Total Users"
        value={stats.total}
        icon={<FaUsers size={14} />}
        iconBgColor="#8b1538"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Active Users"
        value={stats.active}
        icon={<FaCheckCircle size={14} />}
        iconBgColor="#10b981"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Deactivated Users"
        value={stats.deactivated}
        icon={<FaTimesCircle size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Administrators"
        value={stats.admins}
        icon={<FaShieldAlt size={14} />}
        iconBgColor="#f59e0b"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Credit Control"
        value={stats.creditControl}
        icon={<FaDollarSign size={14} />}
        iconBgColor="#6366f1"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Sales Team"
        value={stats.sales}
        icon={<FaChartLine size={14} />}
        iconBgColor="#8b5cf6"
        className="min-w-[177px]"
      />
    </div>
  );
};

export default UserStatsCards;
